import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PortalShell from '../components/PortalShell';
import ResponsiveTable from '../components/ui/ResponsiveTable';
import Button from '../components/ui/Button';
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';
import { formatMoney } from '../utils/currency';
import './PortalInvoices.css';
import { alertDialog } from '../utils/dialogs';
import { openBlobInNewTab } from '../utils/openBlob';

function PortalInvoices() {
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    if (Globals.LoginTime === null) {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    (async () => {
      try {
        setInvoices(await apiClient.get('/api/invoices/mine'));
      } catch (error) {
        console.error('Error fetching invoices:', error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const downloadInvoice = async (invoiceNumber) => {
    setDownloadingId(invoiceNumber);
    try {
      await openBlobInNewTab(async () => {
        const response = await apiClient.raw('/api/invoices/mine/display', {
          method: 'POST',
          body: { invoiceNum: invoiceNumber }
        });
        if (!response.ok) throw new Error('Failed to load invoice');
        return response.blob();
      });
    } catch (error) {
      console.error('Error downloading invoice:', error);
      alertDialog('Could not open that invoice. Please try again.');
    } finally {
      setDownloadingId(null);
    }
  };

  const columns = [
    { key: 'invoice_number', label: 'Invoice', sortable: true },
    {
      key: 'creation_date',
      label: 'Date',
      sortable: true,
      render: (row) => row.creation_date ? new Date(row.creation_date).toLocaleDateString() : '—'
    },
    {
      key: 'amount_payable',
      label: 'Amount',
      sortable: true,
      render: (row) => formatMoney(row.amount_payable, row.currency)
    },
    {
      key: 'payment_status',
      label: 'Status',
      render: (row) => <span className={`portal-status portal-status-${row.payment_status?.toLowerCase().replace(/\s+/g, '-')}`}>{row.payment_status}</span>
    },
    {
      key: 'download',
      label: '',
      render: (row) => (
        <Button
          variant="secondary"
          onClick={() => downloadInvoice(row.invoice_number)}
          disabled={downloadingId === row.invoice_number}
        >
          {downloadingId === row.invoice_number ? 'Opening...' : 'Download'}
        </Button>
      )
    }
  ];

  return (
    <PortalShell>
      <h1>Invoices</h1>
      {loading ? (
        <p>Loading your invoices...</p>
      ) : (
        <ResponsiveTable columns={columns} rows={invoices} rowKey="invoice_number" emptyMessage="You don't have any invoices yet." />
      )}
    </PortalShell>
  );
}

export default PortalInvoices;
